import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Directive, ElementRef, HostListener, Inject, Renderer2 } from '@angular/core';

@Directive({
  selector: '[sharryVideoLoader]',
  standalone: true,
})
export class VideoLoaderDirective implements AfterViewInit {
  private vimeoScript = 'https://player.vimeo.com/api/player.js';
  private youtubeScript = 'https://www.youtube.com/iframe_api';
  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  ngAfterViewInit(): void {
    const placeholders = this.el.nativeElement.querySelectorAll('section.sharry__video-embed');
    if (placeholders.length) {
      placeholders.forEach(p => {
        if (p.getAttribute('data-background-image') && !p.getAttribute('data-background-loaded')) {
          this.renderer.setStyle(p, 'background-image', `url('${p.getAttribute('data-background-image')}')`);
          this.renderer.setAttribute(p, 'data-background-loaded', 'true');
        }
      });
    }
  }

  @HostListener('mouseenter') onHover() {
    const placeholders = this.el.nativeElement.querySelectorAll('section.sharry__video-embed');
    if (placeholders.length) {
      const sources: string[] = [];
      placeholders.forEach(p => {
        if (p.getAttribute('data-background-image') && !p.getAttribute('data-background-loaded')) {
          this.renderer.setStyle(p, 'background-image', `url('${p.getAttribute('data-background-image')}')`);
          this.renderer.setAttribute(p, 'data-background-loaded', 'true');
        }
        const srcAttr = p.getAttribute('data-source');
        if (!sources.find(s => s === srcAttr)) {
          this.preloadApi(p as HTMLElement);
          sources.push(srcAttr);
        }
      });
    }
  }
  @HostListener('click', ['$event.target']) onClick(target: HTMLElement) {
    if (target.hasAttribute('data-video-url')) {
      this.onHover();
      const srcAttr = target.getAttribute('data-source');
      const url = target.getAttribute('data-video-url').split('?')[0];
      const params = target.getAttribute('data-video-url').split('?')[1] || '';
      const iframe = this.document.createElement('iframe');
      iframe.src = `${url}?${srcAttr === 'youtube' ? 'rel=0&autoplay=1&mute=1' : 'autoplay=1&muted=1'}${params
        .replace(/&?autoplay=\d/gi, '')
        .replace(/&?mute=\d/gi, '')
        .replace(/&?muted=\d/gi, '')}`;
      iframe.width = '640';
      iframe.height = '640';
      iframe.frameBorder = '0';
      iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      this.renderer.setStyle(target, 'display', 'none');
      this.renderer.insertBefore(target.parentElement, iframe, target);
    }
  }

  private preloadApi(el: HTMLElement) {
    const source: 'vimeo' | 'youtube' = el.getAttribute('data-source') as any;
    if (source !== 'vimeo' && source !== 'youtube') return;
    if (!this.document.getElementById(`sharry_${source}_script`)) {
      const tag = this.document.createElement('script');
      tag.id = `sharry_${source}_script`;
      const key: 'youtubeScript' | 'vimeoScript' = (source + 'Script') as any;
      tag.src = this[key];
      tag.async = true;
      tag.defer = true;
      this.document.head.appendChild(tag);
    }
  }
}
